import { UpdateParams, CreateParams, UpdateResult, CreateResult } from 'ra-core'

import dataProvider from './dataProvider'
import { toDataURL } from 'src/utils/file'

function uploadMethodFactory(
  m: 'update',
): (r: string, p: UpdateParams) => Promise<UpdateResult>

function uploadMethodFactory(
  m: 'create',
): (r: string, p: CreateParams) => Promise<CreateResult>

function uploadMethodFactory<M extends 'update' | 'create'>(method: M) {
  return async (
    ...[resource, params]: Parameters<(typeof dataProvider)[M]>
  ) => {
    const callSuper = dataProvider[method]

    if (resource === 'resources/api/Image') {
      const image = params.data.imageData
      const dataURL =
        typeof image === 'string' ? image : await toDataURL(image.rawFile)
      const base64 = dataURL?.replace('data:image/png;base64,', '')

      const newParams: UpdateParams & CreateParams = {
        ...(params as UpdateParams & CreateParams),
        data: {
          ...params.data,
          imageData: base64,
        },
      }

      return await callSuper(resource, newParams)
    }

    return await callSuper(resource, params as UpdateParams & CreateParams)
  }
}

const addUploadFeature = {
  ...dataProvider,
  update: uploadMethodFactory('update'),
  create: uploadMethodFactory('create'),
}

export default addUploadFeature
